import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@chargify/custom-ui-components';

import { DetailRow } from '../DetailRow';

export type Props = {
  /**
   * Base plan price
   */
  basePlanPrice: string;
  /**
   * Next billing amount
   */
  nextBillingAmount: string;
  /**
   * Next billing date
   */
  nextBillingDate: string;
};

const Active = ({
  basePlanPrice,
  nextBillingAmount,
  nextBillingDate,
}: Props) => {
  const { t } = useTranslation(['subscriptions-manager']);

  return (
    <Box marginTop={5}>
      <DetailRow
        label={{
          value: t('subscription_details.base_plan_price', {
            ns: 'subscriptions-manager',
          }),
        }}
        value={{
          value: basePlanPrice,
          color: 'success.main',
          fontWeight: 3,
        }}
      />
      <DetailRow
        label={{
          value: t('subscription_details.next_billing_amount', {
            ns: 'subscriptions-manager',
          }),
        }}
        value={{
          value: nextBillingAmount,
          color: 'success.main',
          fontWeight: 3,
        }}
      />
      <DetailRow
        label={{
          value: t('subscription_details.next_billing_date', {
            ns: 'subscriptions-manager',
          }),
        }}
        value={{
          value: nextBillingDate,
          color: 'black.main',
          fontWeight: 0,
        }}
      />
    </Box>
  );
};
export default Active;
